<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Procedure",

  metaInfo: { title: "Prosedur dan Cara Bertransaksi" },

  extends: View,

  mixins: [
    LoadSections([
      "hero-alt",
      "procedure",
      "info"
    ])
  ],

  props: {
    id: {
      type: String,
      default: "procedure"
    }
  }
};
</script>
